import { render, staticRenderFns } from "./forgetpass.vue?vue&type=template&id=ad4b8b18&"
import script from "./forgetpass.vue?vue&type=script&lang=js&"
export * from "./forgetpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports